import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";

interface IProps {
  visible: boolean;
}

export const NotBrandNorRetailerMessage: React.FC<IProps> = ({ visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <Typography>
      <StrictLocalMsg
        defaultMessage="If you’re a brand or retailer, please choose one of the options above to get a response within 24 hours. If you’re not a brand or retailer, please email us at external-requests@faire.com."
        description={{
          img: "https://cdn.faire.com/fastly/cb796ef671cb222817faa535593621ce9975686d802dff1cf33d0adda41f4136.png",
          text: "Message shown to users looking for help in Faire's support center and do not identify as retailer or brands",
        }}
      />
    </Typography>
  );
};
